<template>
  <div id="app" class="app-site" :class="'locale-' + $i18n.locale">
    <Navbar />
    <router-view />
    <foot />
  </div>
</template>
<script>
import Navbar from './layout/index'
export default {
  name: 'App',
  components: { Navbar },
  watch: { '$i18n.locale': { immediate: true, handler (language) { document.documentElement.lang = language === 'zh' ? 'zh-CN' : 'mn'; document.title = this.$t('site.company') } } },
  created () {
    let language = /^zh/i.test(navigator.language || '') ? 'zh' : 'mn'
    try { const saved = localStorage.getItem('eruul-language'); if (saved === 'zh' || saved === 'mn') language = saved } catch (e) { /* Storage is optional. */ }
    this.$i18n.locale = language
    this.$store.commit('setLanguage', language)
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue